import { Filter } from 'app/modules/filters/models';

import {
  getDefaultAiAgentFilters,
  getAiAgentsFiltersKey,
} from 'app/modules/aiAgents/filters';

import { u21CreateAsyncThunk } from 'app/shared/thunk/u21CreateAsyncThunk';
import { u21CreateSlice } from 'app/shared/thunk/u21CreateSlice';

export const AI_AGENTS_SLICE_NAME = 'aiAgents';

interface AiAgentsState {
  alertAgentFilters: Filter[];
  caseAgentFilters: Filter[];
  filingAgentFilters: Filter[];
}

const initialState: AiAgentsState = {
  alertAgentFilters: getDefaultAiAgentFilters(),
  caseAgentFilters: getDefaultAiAgentFilters(),
  filingAgentFilters: getDefaultAiAgentFilters(),
};

export const setAlertAiAgentFilters = u21CreateAsyncThunk<Filter[], Filter[]>(
  `${AI_AGENTS_SLICE_NAME}/SET_ALERT_AI_AGENT_FILTERS`,
  (payload) => {
    localStorage.setItem(
      getAiAgentsFiltersKey('u21_provided'),
      JSON.stringify(payload),
    );
    return payload;
  },
);

export const setCaseAiAgentFilters = u21CreateAsyncThunk<Filter[], Filter[]>(
  `${AI_AGENTS_SLICE_NAME}/SET_CASE_AI_AGENT_FILTERS`,
  (payload) => {
    localStorage.setItem(
      getAiAgentsFiltersKey('case'),
      JSON.stringify(payload),
    );
    return payload;
  },
);

export const setFilingAiAgentFilters = u21CreateAsyncThunk<Filter[], Filter[]>(
  `${AI_AGENTS_SLICE_NAME}/SET_FILING_AI_AGENT_FILTERS`,
  (payload) => {
    localStorage.setItem(
      getAiAgentsFiltersKey('filing'),
      JSON.stringify(payload),
    );
    return payload;
  },
);

export const aiAgentsSlice = u21CreateSlice({
  initialState,
  name: AI_AGENTS_SLICE_NAME,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setAlertAiAgentFilters.fulfilled, (draft, action) => {
      draft.alertAgentFilters = action.payload;
    });
    builder.addCase(setCaseAiAgentFilters.fulfilled, (draft, action) => {
      draft.caseAgentFilters = action.payload;
    });
    builder.addCase(setFilingAiAgentFilters.fulfilled, (draft, action) => {
      draft.filingAgentFilters = action.payload;
    });
  },
});

export const aiAgentsReducer = aiAgentsSlice.reducer;
